import Cookies from 'js-cookie'

const state = {
  name: ''
}

const mutations = {
  setName: (state, data) => {
    if (data) {
      Cookies.set('userName', encodeURIComponent(data), {
        expires: 365 * 100
      })
    } else {
      Cookies.remove('userName')
    }
    state.name = data
  }
}

export default {
  namespaced: true,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user/index.js